export default __webpack_public_path__ + "static/media/consult-active-tab-icon.285f8c55.svg";